import { confirmar } from '../../../../libs/cifra/dialogs';
import { showApiErrors } from '../../../../libs/cifra/flash';
import Overlay from '../../../../libs/cifra/overlay';

export function getListadoController(elementWrapper) {
  return window.Stimulus.getControllerForElementAndIdentifier(
    (elementWrapper || document).querySelector('[data-controller="listado"]'),
    'listado',
  );
}

/**
 * Clase para gestionar cuando en un listado (ListadoView) tiene las filas un check
 * para marcarlas y realizar acciones con ellas, etc. Para inicializar el proceso
 * hay que llamar al método connect().
 *
 * También se encarga de habilitar y deshabilitar los botones de acción según la selección
 * que hay en el listado pasándole la opción "selectorBotonesAccion"
 */
export default class GestorSeleccionListado {
  constructor(element, options = {}) {
    this.element = element;
    this.changeCallback = options.changeCallback;

    const config = { ...this.element.dataset };
    this.selectorChecks = config.selectorChecks || '.cifra-listado-body input[type=checkbox]';
    this.selectorBotonesAccion = config.selectorBotonesAccion || '.btn-accion';
  }

  connect() {
    if (this.selectorBotonesAccion) {
      this.botonesAccion = this.element.querySelectorAll(this.selectorBotonesAccion);
    } else {
      this.botonesAccion = undefined;
    }
    this.#conectarEventosGenerales();
    this.#conectarEventosListado();
  }

  disconnect() {
    this.#desconectarEventosGenerales();
  }

  getCheckboxes() {
    return [...this.element.querySelectorAll(this.selectorChecks)].filter((check) => {
      if (check.disabled && !check.dataset.busquedaCompleta) {
        return false;
      }
      return true;
    });
  }

  getCheckboxesMarcados() {
    return this.getCheckboxes().filter((c) => c.checked);
  }

  // Si es la búsqueda completa devuelve undefined, si no hay nada
  // seleccionado devolvería un array vacío.
  getValoresSeleccionados() {
    if (this.busquedaCompletaMarcada) {
      return undefined;
    }

    const checks = this.getCheckboxesMarcados();
    return checks.map((c) => c.value);
  }

  getParametrosFiltros() {
    return {
      search_token: this.element.querySelector('.search_token').value,
      busqueda_completa: this.isBusquedaCompletaMarcada(),
      ids: this.getValoresSeleccionados(),
    };
  }

  isBusquedaCompletaMarcada() {
    return this.botonSeleccionarTodo?.busquedaCompletaMarcada || false;
  }

  lanzarBusqueda() {
    this.#getListadoController().lanzarBusqueda();
  }

  /**
   * Pide confirmación de la acción y si aceptan llama a la api pasándole los parámetros
   * de la selección del lisado. Si responde bien recargamos el listado
   */
  confirmarBotonAccion(boton, titulo, texto, apiRequest) {
    boton.addEventListener('click', () => {
      confirmar({
        title: titulo,
        text: texto,
      }).then((confirmado) => {
        if (confirmado) {
          const overlay = new Overlay(this.element);
          overlay.show();
          apiRequest(
            this.getParametrosFiltros(),
          ).then(() => {
            this.lanzarBusqueda();
          }).catch((error) => {
            showApiErrors(error);
          }).finally(() => {
            overlay.hide();
          });
        }
      });
    });
  }

  #conectarEventosGenerales() {
    this.callbackRecargarListado = (_event) => {
      this.lanzarBusqueda();
    };
    // Si lanzan este evento en el documento, recargaremos el listado
    document.addEventListener('recargar-listado', this.callbackRecargarListado);
  }

  #desconectarEventosGenerales() {
    // La función está guardada en la clase al conectar para ahora desconectarla
    document.removeEventListener('recargar-listado', this.callbackRecargarListado);
  }

  #conectarEventosListado() {
    this.element.querySelector('[data-controller="listado"]').addEventListener('listado:updated', () => {
      this.#onListadoUpdated();
    });

    // Llamamos la primera vez
    this.#onListadoUpdated();
  }

  #onListadoUpdated() {
    this.#conectarChecks();
    this.#conectarBotonSeleccionarTodo();
    this.#onChangeSeleccion();
  }

  #conectarChecks() {
    this.getCheckboxes().forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.#onChangeSeleccion();
      });
    });
  }

  #conectarBotonSeleccionarTodo() {
    // Sin el setTimeout todavía no ha cargado el controller y no lo encuentra
    setTimeout(() => {
      this.botonSeleccionarTodo = window.Stimulus.getControllerForElementAndIdentifier(
        this.element.querySelector('[data-controller="seleccionar-todo"]'),
        'seleccionar-todo',
      );
    });
  }

  #onChangeSeleccion() {
    if (this.botonesAccion) {
      const checksMarcados = this.getCheckboxesMarcados();
      this.botonesAccion.forEach((boton) => {
        boton.disabled = checksMarcados.length === 0;
      });
    }

    if (this.changeCallback) {
      this.changeCallback();
    }
  }

  #getListadoController() {
    return getListadoController(this.element);
  }
}
